module.exports = __webpack_public_path__ + "static/img/Agnes_N_2020.dc20c1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bssp/Agnes_N_2020.jpg
// module id = 125
// module chunks = 2